import { c as _c } from "react/compiler-runtime";
import RangeInput from "@components/hookform/RangeInput";
import { Control } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from "./interfaces";
export interface InputFieldProps<T extends FieldValues> {
  control: Control<T>;
  fieldDefinition: FormFieldDefinition<T>;
  autoFocus?: boolean;
}
const RangeField = t0 => {
  const $ = _c(6);
  const {
    control,
    fieldDefinition
  } = t0;
  let t1;
  if ($[0] !== control || $[1] !== fieldDefinition.label || $[2] !== fieldDefinition.name || $[3] !== fieldDefinition.placeholder || $[4] !== fieldDefinition.rules) {
    t1 = <div className="flex relative max-w-[360px]"><RangeInput control={control} name={fieldDefinition.name} label={fieldDefinition.label} rules={fieldDefinition.rules} placeholder={fieldDefinition.placeholder} /></div>;
    $[0] = control;
    $[1] = fieldDefinition.label;
    $[2] = fieldDefinition.name;
    $[3] = fieldDefinition.placeholder;
    $[4] = fieldDefinition.rules;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default RangeField;